// User Permission Endpoints Constants
export const USER_PERMISSION_ENDPOINTS = {
  // User Permissions
  USER_PERMISSION: "/user/permission",
  USER_PERMISSION_BY_ID: (userId: string | number) => `/user/${userId}/permission`,
  USER_PERMISSION_HISTORY: (userId: number) => `/user/${userId}/permission/history`,
  USER_GROUP_PERMISSION: (userId: number, userGroupId: number) =>
    `/user/${userId}/permission/${userGroupId}`,

  // Groups
  GROUP: "/group",
  GROUP_BY_ID: (groupId: number) => `/group/${groupId}`,
  GROUP_HISTORY: (groupId: number) => `/group/${groupId}/history`,

  // Permissions
  PERMISSION: "/permission",
} as const;
